import { useMerchantInfo } from '@/store/merchant-info-module';
import { useReturningUserStore } from '@/store/returning-user-module';
import { ReturnCodeAct } from '@tencent/wphk-components-returning-user/business/returnCodeAct';
import { computed, toRefs } from 'vue';

/** 用户是否领取回流券，用于埋点 */
const userGotCouponStatus = (returnCodeAct: ReturnCodeAct) => {
  const userCoupons = returnCodeAct.getUserCoupons() || [];
  return userCoupons.length > 0 ? '1' : '0';
};

export const useBiReport = () => {
  const { merchantId } = toRefs(useMerchantInfo());
  const { returnCodeActInfo } = toRefs(useReturningUserStore());
  const biExt = computed(() => ({
    fmerchantid: merchantId.value,
    fuserbackstatus: userGotCouponStatus(returnCodeActInfo.value as ReturnCodeAct),
  }));

  return {
    biExt,
  };
};
